<template>
  <v-list-item>
    <v-list-item-avatar>
      <v-icon v-if="course.result === 2">mdi-check-bold</v-icon>
      <v-icon v-else-if="course.result === 1">mdi-close-thick</v-icon>
    </v-list-item-avatar>

    <v-list-item-content class="resp-fix">
      <v-list-item-title
        >{{ course.name }} -
        <span
          :class="[
            'font-weight-bold',
            {
              'green--text': course.result === 2,
              'red--text': course.result === 1
            }
          ]"
          >{{ course.result === 2 ? 'UKOŃCZONO' : 'NIE UKOŃCZONO' }}</span
        >
      </v-list-item-title>
    </v-list-item-content>

    <v-list-item-action v-if="course.started">
      <v-dialog v-model="dialog" max-width="800">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on">
            <v-icon left>mdi-certificate-outline</v-icon>
            Pokaż wynik
          </v-btn>
        </template>
        <v-card>
          <v-toolbar color="green" dark flat>
            <v-toolbar-title>Wynik</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="mt-4">
            <v-row>
              <v-col>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="headline">Rezultat</v-list-item-title>
                    <v-list-item-subtitle
                      :class="[
                        'mt-2',
                        'title',
                        {
                          'green--text': course.result === 2,
                          'red--text': course.result === 1
                        }
                      ]"
                      >{{ course.result === 2 ? 'UKOŃCZONO' : 'NIE UKOŃCZONO' }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="headline">Procent punktów</v-list-item-title>
                    <v-list-item-subtitle class="mt-2 title">{{
                      course.result === 2 && course.score === null ? '100%' : `${course.score===null?0:course.score}%`
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="dialog = false">Zamknij</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      dialog: false
    };
  }
};
</script>

<style lang="scss" scoped>
.resp-fix {
  max-width: 100px;
}

@for $i from 18 through 26 {
  @media (min-width: #{$i * 50}px) {
    .resp-fix {
      max-width: #{($i * 50) - 550}px;
    }
  }
}

@media (min-width: 1370px) {
  .resp-fix {
    max-width: 100%;
  }
}
</style>
